import styled, { css } from 'styled-components'
import { TypePrius } from '@at/design-system-foundation'

export const FilterHeader = styled.div`
    display: flex;
    justify-content: space-between;
    scroll-margin-top: 35px;
`

export const FilterHeading = styled.div`
    display: inline-block;
    align-items: center;
`

export const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`

export const TitleAndBadgeWrapper = styled.div`
    display: flex;
    gap: 10px;
`

export const FilterSelectedValue = styled(TypePrius)<{ $isLeisureOrTPF: boolean }>`
    font-variation-settings: 'wght' 400;
    color: ${({ theme }) => theme.color.text.default};
    height: 24px;
    padding: ${({ $isLeisureOrTPF }) => ($isLeisureOrTPF ? '4px 0' : '4px 0 4px 34px')};
    display: flex;
    justify-content: flex-start;
    text-align: start;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
`

export const FilterClickable = styled.button<{
    withDisplayValue: boolean
    isFilterOpen: boolean
    shouldGreyOut: boolean
    disabled: boolean
    alwaysOpen: boolean
}>`
    ${({ withDisplayValue, shouldGreyOut, disabled, isFilterOpen, theme, alwaysOpen }) => {
        const getPadding = (): string => {
            if (withDisplayValue && !isFilterOpen) {
                return '16px 0'
            }
            if (alwaysOpen) {
                return '28px 0 16px 0'
            }
            return '28px 0'
        }

        return css`
            padding: ${getPadding()};

            path,
            & p {
                fill: ${shouldGreyOut ? 'currentColor' : ''};
                color: ${shouldGreyOut ? theme.color.text.disabled : ''};
            }

            background: none;
            border: none;
            width: 100%;
            cursor: ${disabled ? 'not-allowed' : alwaysOpen ? 'cursor' : 'pointer'};
            -webkit-tap-highlight-color: transparent;

            &:focus-visible {
                outline: ${({ theme }) => `2px solid ${theme.color.border.focus}`};
            }
        `
    }}
`

export const ChevronWrapper = styled.div<{ isFilterOpen: boolean; shouldGreyOut: boolean; disabled: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ theme, isFilterOpen, disabled }) => css`
        path {
            fill: ${isFilterOpen
                ? theme.color.icon.default // active
                : disabled
                ? 'currentColor'
                : ''};
        }
        transform: ${!isFilterOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
        transition-property: transform, fill;
        transition-duration: 250ms;
        transform-origin: 50% 50%;
    `}
`
